import { EditorState } from 'draft-js'

export type LineClampOptions = 1 | 2 | 3

export interface EditorProps {
  placeholder?: string
  value?: EditorState
  readOnly?: boolean
  onChange?: (editorState: EditorState) => void
  maxPlainTextLength?: number
  lineClamp?: LineClampOptions
}
